import { Component, computed, input } from '@angular/core';
import { OtapUpgradeTaskDTO } from '@app/shared/models/otap-upgrade-task.interface';

@Component({
  selector: 'app-job-tasks-tile',
  templateUrl: './job-tasks-tile.component.html',
  styleUrls: ['./job-tasks-tile.component.scss'],
  imports: []
})
export class JobTasksTileComponent {
  readonly task = input.required<OtapUpgradeTaskDTO>();
  readonly dataSource = computed(() => {
    const task = this.task();
    const status = task.statuses?.[0];
    return {
      startedDateTime: status?.startedDateTime ?? null,
      endedDateTime: status?.endedDateTime ?? null,
      count: status?.count ?? null,
      expectedCount: task.expectedCount
    };
  });

  public dateInLocale(date: Date): string {
    return date ? new Date(date).toLocaleString() : new Date().toLocaleString();
  }
}
